const formTools = {
    translations: {
        'uk': {
            phone_required: 'Введіть номер телефону',
            name_required: 'Введіть ім\'я',
            load_up_to: 'Завантажити файли (до 5 МБ)',
            recaptcha_failed: 'Помилка перевірки reCAPTCHA. Спробуйте ще раз.'
        },
        'ru': {
            phone_required: 'Введите номер телефона',
            name_required: 'Введите имя',
            load_up_to: 'Загрузить файлы (до 5 МБ)',
            recaptcha_failed: 'Ошибка проверки reCAPTCHA. Попробуйте еще раз.'
        },
        'en': {
            phone_required: 'Enter your phone number',
            name_required: 'Enter name',
            load_up_to: 'Upload files (up to 5MB)',
            recaptcha_failed: 'reCAPTCHA verification failed. Please try again.'
        },
    },

    addLead: function (formData, form) {
        const btn = form.find('.send_form');
        btn.prop('disabled', true);

        grecaptcha.ready(function () {
            grecaptcha.execute('6LdPa-grAAAAAD-VewgLORe7lqXDspolLL4UQYtm', { action: 'submit_form' }).then(function (token) {
                formData.append('g-recaptcha-response', token);

                $.ajax({
                    url: requests.addLead,
                    type: 'POST',
                    data: formData,
                    processData: false,
                    contentType: false,
                    success: function (data) {
                        if (data.status === "ok") {
                            sendFormEvents(form.attr('data-subject'));
                            form.find('.modal__item').val('');
                            form.find('.reviews-page__upload-name').text(formTools.translations[lang]['load_up_to'] || 'Upload files (up to 5MB)');

                            const successBlock = form.closest('.modal__box').find('.modal__success');
                            successBlock.addClass('active');

                            setTimeout(function () {
                                successBlock.removeClass('active');
                                window.location.reload();
                            }, 3000);
                        } else if (data.status === "error" && data.message === "reCAPTCHA verification failed") {
                            alert(formTools.translations[lang]['recaptcha_failed'] || 'reCAPTCHA verification failed. Please try again.');
                        }
                    },
                    error: function (xhr) {
                        console.error('Error:', xhr.responseText);
                        alert(formTools.translations[lang]['recaptcha_failed'] || 'An error occurred. Please try again.');
                    },
                    complete: function () {
                        btn.prop('disabled', false);
                    }
                });
            }).catch(function (error) {
                console.error('reCAPTCHA error:', error);
                alert(formTools.translations[lang]['recaptcha_failed'] || 'reCAPTCHA failed to load. Please try again.');
                btn.prop('disabled', false);
            });
        });
    },

    displayFileInfo: function (files, uploadNameElement) {
        if (files.length === 0) {
            uploadNameElement.text(this.translations[lang]['load_up_to'] || 'Upload files (up to 5MB)');
            return;
        }

        let fileInfo = '';
        Array.from(files).forEach((file, index) => {
            const fileName = file.name;
            const fileSize = (file.size / 1024 / 1024).toFixed(2); // Convert to MB
            const fileExtension = fileName.split('.').pop().toLowerCase();
            fileInfo += `${fileName} (${fileSize} MB, ${fileExtension})`;
            if (index < files.length - 1) {
                fileInfo += '<br>';
            }
        });
        uploadNameElement.html(fileInfo);
    },

    initValidate: function (node = '.modal__form') {
        $(node).each(function () {
            $(this).validate({
                rules: {
                    user_phone: {
                        required: true,
                    },
                    user_first_name: {
                        required: true,
                        minlength: 2
                    },
                },
                messages: {
                    user_phone: {
                        required: formTools.translations[lang]['phone_required'],
                    },
                    user_first_name: {
                        required: formTools.translations[lang]['name_required'],
                    },
                }
            });

            const form = $(this);
            const fileInput = form.find('input[type="file"]');
            const uploadNameElement = form.find('.reviews-page__upload-name');

            fileInput.on('change', function () {
                formTools.displayFileInfo(this.files, uploadNameElement);
            });
        });
    }
}

$(document).ready(function () {
    formTools.initValidate();
    $(document).on('click', '.send_form', function (e) {
        e.preventDefault();
        const form = $(this).closest('.modal__form');
        if (!form.valid()) {
            return;
        }

        const formData = new FormData(form[0]);
        formData.append('subject', form.attr('data-subject'));

        formTools.addLead(formData, form);
    });
});
window.initValidate = formTools.initValidate;
